import {Component, ElementRef, OnInit} from '@angular/core';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  current_year: number = new Date().getFullYear();
  whitelabel = false;
  whitelabeledCompany = false;
  dataManager: DataManagerService;
  constructor(private elRef: ElementRef,  dataManager: DataManagerService) {
    this.dataManager = dataManager;
  }

  ngOnInit() {
    this.whitelabel = this.dataManager.user['merchant_dashboard_whitelabeled'] || false;
    if (this.whitelabel) {
      this.whitelabeledCompany = this.dataManager.user['merchant_dashboard_whitelabeled_company'];
    }
  }
}
